module.exports = __webpack_public_path__ + "img/alpha-feedback.4ee29a3a.svg";